import React, {useEffect } from "react";
import { Modal, Form, Input, Button } from "antd";
import "./Payment.scss";
import { useSelector } from "react-redux";

export default function LinkPaymentModal(props) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const adminRestaurant = useSelector((state) => state.admin);

  useEffect(() => {
    if (props.isEdit) {
      console.log(props.updatedLink);
      formRef.current.setFieldsValue({
        client_secret: props.updatedLink?.client_secret,
        client_id: props.updatedLink?.client_id,
      });
    }
  }, [props]);

  const LinkAdmin = async (values) => {
    const payload = {
      restaurant_id: adminRestaurant,
      client_id: values.client_id,

      client_secret: values.client_secret,
    };

    if (props.isEdit) {
      props.updateProvider(payload);
    } else {
      // const data = await PaymentService.linkProviders(testimonials);
      // message.success("Added Successfully")
      props.addProvider(payload);
    }
    props.closeModal(false);
  };

  return (
    <Modal
      title={props.isEdit ? "Link Account" : "Link Account"}
      visible={props.modalOpen}
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <Form ref={formRef} form={form} onFinish={LinkAdmin} layout="vertical">
        <Form.Item
          name="client_id"
          label="Client Id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />

        </Form.Item>
        
          <Form.Item
            name="client_secret"
            label="Client Secret"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        

        <Form.Item className="button-form">
          <Button type="primary" htmlType="submit">
            Link
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
